import request from '@/utils/request'

function withRepairQuery(repairId, extraParams = {}) {
  const params = {
    page: 1,
    row: 1,
    ...extraParams,
    repairId
  }
  return params
}

function getFirstRepair(res) {
  const rows = Array.isArray(res.data) ? res.data : []
  return rows[0] || null
}

// 获取工单详情
export function getRepairDetail(repairId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.listOwnerRepairs',
      method: 'get',
      params: withRepairQuery(repairId)
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const repair = getFirstRepair(res)
        repair ? resolve(repair) : reject(new Error('工单不存在或无权限查看'))
      } else {
        reject(new Error(res.msg || '获取工单详情失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取工单图片
export function getRepairPhotos(repairId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.listOwnerRepairs',
      method: 'get',
      params: withRepairQuery(repairId)
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const repair = getFirstRepair(res)
        resolve({
          photos: repair ? (repair.repairPhotos || []) : [],
          beforePhotos: repair ? (repair.beforePhotos || []) : [],
          afterPhotos: repair ? (repair.afterPhotos || []) : []
        })
      } else {
        reject(new Error(res.msg || '获取工单图片失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取维修物品
export function getRepairResources(repairId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStore.listResourceStoreUseRecords',
      method: 'get',
      params: withRepairQuery(repairId, {
        page: 1,
        row: 100
      })
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const resources = (res.data || []).map(item => {
          if (item.resId === '666666') {
            return { ...item, rstName: '自定义', specName: '自定义' }
          }
          return item
        })
        resolve(resources)
      } else {
        reject(new Error(res.msg || '获取维修物品失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取工单流转
export function getRepairFlow(repairId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.listRepairStaffs',
      method: 'get',
      params: withRepairQuery(repairId, {
        page: 1,
        row: 100
      })
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data || [])
      } else {
        reject(new Error(res.msg || '获取工单流转失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取工单事件
export function getRepairEvents(repairId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/repair.listRepairEvent',
      method: 'get',
      params: withRepairQuery(repairId, {
        page: 1,
        row: 100
      })
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data || [])
      } else {
        reject(new Error(res.msg || '获取工单事件失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 回复评价
export function replyAppraise(data) {
  return new Promise((resolve, reject) => {
    const payload = { ...data }
    request({
      url: '/repair.replyRepairAppraise',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve()
      } else {
        reject(new Error(res.msg || '回复评价失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
